module.exports = __webpack_public_path__ + "img/Flag_of_El_Salvador.12033f1e.svg";